import { useEffect, useState } from "react";
import { RESET } from "jotai/utils";

import { useOrganizationsQuery } from "src/generated/graphql";
import { OrganizationsQuery, SortOrder } from "src/generated/graphql";
import { useAtom } from "jotai";
import { organizationsAtom } from "src/shame/shame-atoms";

const PAGE_SIZE = 500; // Number of organizations to fetch per page

export const useGetAllOrganizations = () => {
	const [organizations, setOrganizations] = useAtom(organizationsAtom);
	const [needToGetMoreOrgs, setNeedToGetMoreOrgs] = useState(true);
	const orderBy = [{ name: SortOrder.Asc }];
	const where = { deletedAt: { equals: null } };
	const [localOrganizations, setLocalOrganizations] = useState<OrganizationsQuery["organizations"]>([]);

	const {
		data,
		isLoading,
		error,
		refetch: refetchOrganizations,
	} = useOrganizationsQuery(
		{
			orderBy,
			where,
			take: PAGE_SIZE,
			skip: localOrganizations?.length || 0,
		},
		{
			enabled: needToGetMoreOrgs,
		},
	);

	useEffect(() => {
		if (data?.organizations?.length) {
			setLocalOrganizations((prev) => {
				const organizationsById = new Map(prev.map((org) => [org.id, org]));
				for (const org of data.organizations) organizationsById.set(org.id, org);
				return Array.from(organizationsById.values());
			});
			setNeedToGetMoreOrgs(data.organizations.length === PAGE_SIZE);
		} else {
			setNeedToGetMoreOrgs(false);
		}
	}, [data]);

	useEffect(() => {
		if (!needToGetMoreOrgs) {
			setOrganizations(localOrganizations);
		}
	}, [needToGetMoreOrgs, localOrganizations, setOrganizations]);

	const refetch = () => {
		setOrganizations(RESET);
		setNeedToGetMoreOrgs(true);
		refetchOrganizations();
	};

	return { organizations, isLoading, error, needToGetMoreOrgs, refetch };
};
